import {
  ComposableDashboardFiltersEnum,
  getMyPinnedDashboardsCollection,
  IComposableAnalyticsGlobalFilters,
  selectedOrganizationalUnitManagers,
  selectedOrganizationalUnitTeams,
} from 'wisestep-api';

export const GetDashboardFilters = async (data) => {
  try {
    const { param, payload } = data;
    const filters = {} as Record<ComposableDashboardFiltersEnum, IComposableAnalyticsGlobalFilters>;
    let teamIdsSelected: string[] = [];
    let managerIdsSelected: string[] = [];
    if (param === 'Teams') filters[ComposableDashboardFiltersEnum.TEAM] = { teamIds: [payload.id] };
    else if (param === 'AccountManager')
      filters[ComposableDashboardFiltersEnum.ACCOUNT_MANAGER] = { accountManagers: [payload.id] };
    else if (param === 'DeliveryUnit') {
      const responseTeam = await selectedOrganizationalUnitTeams(payload.id);
      teamIdsSelected = responseTeam?.data?.map((item) => item.teamId) || [];
      filters[ComposableDashboardFiltersEnum.TEAM] = { teamIds: teamIdsSelected };
    } else if (param === 'AccountManagerUnit') {
      const responseManager = await selectedOrganizationalUnitManagers(payload.id);
      managerIdsSelected = responseManager.data.map((item) => item.accountManagerId) || [];
      filters[ComposableDashboardFiltersEnum.ACCOUNT_MANAGER] = {
        accountManagers: managerIdsSelected,
      };
    }
    return filters;
  } catch (error) {
    return {};
  }
};

export const getPinnedDashboardIds = async (entityIdCheck) => {
  try {
    const responseCollection = await getMyPinnedDashboardsCollection();
    if (responseCollection.data?.length > 0) {
      responseCollection.data?.filter((item) => item?.entityId === entityIdCheck).length;
    }
  } catch (error) {
    return {};
  }
};
